import { type IconType } from "@clipboard-health/ui-components";
import { isDefined } from "@clipboard-health/util-ts";
import pluralize from "pluralize";

import { Window } from "../Open/types";
import { ShiftBottomSheetBookabilityCriteriaCard } from "./BookabilityCriteriaCard";
import { useReliableWindowingSequence } from "./useReliableWindowingSequence";

export interface ShiftBottomSheetPriorityShiftCardProps {
  workplaceId: string;
  window?: Window;
}

export function ShiftBottomSheetPriorityShiftCard(props: ShiftBottomSheetPriorityShiftCardProps) {
  const { workplaceId, window } = props;
  const { minVerifiedShiftsForFamiliarity, daysToEvaluateFamiliarity } =
    useReliableWindowingSequence(workplaceId);

  let icon: IconType = "scalloped-diamond-with-star-colored";
  let description =
    "You're getting early access to this shift because you have a high Clipboard Score. Keep it up!";

  if (isDefined(window) && window === Window.RELIABLE_AND_FAMILIAR) {
    icon = "scalloped-user-badge-with-star-colored";
    description = `You have early access because you've worked at least ${minVerifiedShiftsForFamiliarity} ${pluralize(
      "shift",
      minVerifiedShiftsForFamiliarity
    )} in the past ${daysToEvaluateFamiliarity} days at this workplace.`;
  }

  if (isDefined(window) && window === Window.FAVORITE_WORKPLACE) {
    icon = "scalloped-user-badge-with-star-colored";
    description = "You have early access because this is a shift from your favorite workplace.";
  }

  return (
    <ShiftBottomSheetBookabilityCriteriaCard
      intent="priority"
      title="You have Priority Access to this shift!"
      description={description}
      illustrationType="priority"
      icon={icon}
    />
  );
}
